// @flow

import 'isomorphic-fetch'
import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { getErrorAction } from '../utils/actions'
import type { Action } from '../types/actions/quests'
import type { APIError } from '../types'
import { getQuestFilterQuery } from '../utils/quests'

export const CLEAR_QUESTS = 'CLEAR_QUESTS'
export const FETCH_QUESTS_REQUEST = 'FETCH_QUESTS_REQUEST'
export const FETCH_QUESTS_SUCCESS = 'FETCH_QUESTS_SUCCESS'
export const FETCH_QUESTS_FAILURE = 'FETCH_QUESTS_FAILURE'

export function clearQuests(): Action {
  return {
    type: CLEAR_QUESTS
  }
}

export function fetchQuestsRequest(): Action {
  return {
    type: FETCH_QUESTS_REQUEST
  }
}

export function fetchQuestsSuccess(response: Object): Action {
  return {
    type: FETCH_QUESTS_SUCCESS,
    quests: response.quests,
    page: response.meta.page,
    total: response.meta.total
  }
}

export function fetchQuestsFailure(error: APIError): Action {
  return getErrorAction(FETCH_QUESTS_FAILURE, error)
}

export function fetchQuests(
  page: ?number,
  clearQuestsInState: ?boolean
): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const query = getQuestFilterQuery(
      state.questsfilters,
      state.organization.orgId,
      state.user.user
    )
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/search`

    if (clearQuestsInState) {
      dispatch(clearQuests())
    }

    dispatch(fetchQuestsRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            page: page,
            q: query
          })
        })
      )
      const json = await response.json()
      dispatch(fetchQuestsSuccess(json))
    } catch (error) {
      dispatch(fetchQuestsFailure(error))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/quests.js